export default __webpack_public_path__ + "static/media/31_G.e8f0b6e2.svg";